import type { UseFormRegisterReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export interface EmailInputProps {
  register: UseFormRegisterReturn;
  error?: string;
  disabled?: boolean;
  className?: string;
}

export function EmailInput({
  register,
  error,
  disabled = false,
  className,
}: EmailInputProps) {
  const { t } = useTranslation();

  return (
    <div className={`space-y-2 ${className || ''}`}>
      <div className="flex items-center justify-between">
        <Label htmlFor="user-email" className="text-sm font-medium">
          {t('form.userEmail.label')}
        </Label>
      </div>
      <Input
        {...register}
        id="user-email"
        type="email"
        placeholder={t('form.userEmail.placeholder')}
        disabled={disabled}
        className={error ? 'border-destructive focus-visible:ring-destructive' : ''}
        aria-invalid={error ? 'true' : 'false'}
        aria-describedby={error ? 'user-email-error' : undefined}
      />
      {error && (
        <p id="user-email-error" className="text-sm text-destructive" role="alert">
          {error}
        </p>
      )}
    </div>
  );
}
